import { render, staticRenderFns } from "./GeneralUser.vue?vue&type=template&id=6f87f8a1&scoped=true&"
import script from "./GeneralUser.vue?vue&type=script&lang=js&"
export * from "./GeneralUser.vue?vue&type=script&lang=js&"
import style0 from "./GeneralUser.vue?vue&type=style&index=0&id=6f87f8a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87f8a1",
  null
  
)

export default component.exports